import { render, staticRenderFns } from "./InboundStatusPill.vue?vue&type=template&id=0450cfc2&"
import script from "./InboundStatusPill.vue?vue&type=script&lang=js&"
export * from "./InboundStatusPill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports